import React from 'react';
import UnifiedBookCard from './UnifiedBookCard';
interface CharacterRelationship {
  type: string;
  style?: string[];
  characters?: string;
}
interface Book {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  rating: number;
  formats?: string[];
  genres?: string[];
  isNew?: boolean;
  isDebut?: boolean;
  heatLevel?: number;
  darknessLevel?: number;
  endingType?: string;
  characterRelationships?: CharacterRelationship[];
  reviewCount?: number | string;
  subgenres?: string[];
  spiceLevel?: number;
  contentWarnings?: string[];
  seriesName?: string;
  seriesStatus?: string;
  seriesNumber?: number;
  totalSeriesBooks?: number;
}
interface Series {
  id: string;
  name: string;
  status: string; // 'ongoing', 'completed', 'hiatus'
  books: Book[];
  totalBooks: number;
}
interface BooksGridProps {
  standalones?: Book[];
  seriesList?: Series[];
  books?: Book[]; // For backwards compatibility
  columns?: number;
  className?: string;
  viewMode?: 'grid' | 'list';
  darkMode?: boolean;
}
const BooksGrid: React.FC<BooksGridProps> = ({
  standalones = [],
  seriesList = [],
  books = [],
  columns = 4,
  className = '',
  viewMode = 'grid',
  darkMode = false
}) => {
  const allStandalones = [...standalones, ...books];
  // Standard responsive grid: 2 → 3 → 4 → 5 columns
  const gridClass = `grid grid-cols-2 sm:grid-cols-3 md:grid-cols-${columns} lg:grid-cols-5 gap-4 sm:gap-6 ${className}`;
  return <div className={gridClass} data-id="element-1025" data-mp="39eoz4hys0q06">
      {/* Render standalone books with consistent sizing */}
      {allStandalones.map(book => <div className="flex-shrink-0 w-full" key={`book-${book.id}`} data-id="element-1026" data-mp="34gnis4sqj4se">
          <UnifiedBookCard book={book} darkMode={darkMode} data-id="element-1027" data-mp="3if509ks1rl1v" />
        </div>)}
      {/* Render series with consistent sizing */}
      {seriesList.map(series => <div className="flex-shrink-0 w-full" key={`series-${series.id}`} data-id="element-1028" data-mp="xnlb0ndp7pjc">
          <UnifiedBookCard series={series} darkMode={darkMode} data-id="element-1029" data-mp="sp1oolv70bqg" />
        </div>)}
    </div>;
};
export default BooksGrid;